import React from 'react'
import logoLatitud from "../../img/logoLatitudSur.png";
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

const ModalPreLoginTres = ({modalPreLogin, setModalPreLogin}) => {
   
   return (
      <>
         <div className={`popup ${modalPreLogin}`} id="popup">
            <div className='overlay'></div>
            <div className='popup-content'>
               {/* <div className="modal-prelogin-picture">
                  <img src={logoLatitud} alt="" className="responsive-img modal-prelogin-img"/>
               </div> */}
               <h2>Bienvenido a Mi Latitud</h2>
               <p>
                  Seleccione el seguro que desea gestionar
               </p>
                  <div className="row">
                     <div className="col s12 m12">
                        <ul id="nav-mobile" className="nav-center hide-on-med-and-down">
                           <li><a rel="noopener noreferrer" target='_blank' className="btn-gestion" href={"https://art.latitudsursa.com.ar"}>ART</a></li>
                           {/* <li><NavLink className="btn-gestion" onClick={""}>GRANIZO</NavLink></li>
                           <li><NavLink className="btn-gestion" onClick={""}>AUTOMOTOR</NavLink></li>
                           <li><NavLink className="btn-gestion" onClick={""}>SOY PRESTADOR MÉDICO</NavLink></li> */}
                           {/* <li><NavLink className="btn-login" target="_blank" to={"art/auth/login"}>Mi Latitud</NavLink></li> */}
                        </ul>
                     </div>
                  </div>
               {/* <div className="row">
                  <div className="col s12 m4">
                     <div className="card">
                        <div className="card-image">
                           <img src={logoLatitud} alt="" className="responsive-img padding-img modal-prelogin-img"/>
                        </div>
                        <div className="card-action center">
                           <a href="#">ART</a>
                        </div>
                     </div>
                  </div>
                  <div className="col s12 m4">
                     <div className="card">
                        <div className="card-image">
                           <img src={logoLatitud} alt="" className="responsive-img padding-img modal-prelogin-img"/>
                        </div>
                        <div className="card-action center">
                           <a href="#">GRANIZO</a>
                        </div>
                     </div>
                  </div>
                  <div className="col s12 m4">
                     <div className="card">
                        <div className="card-image">
                           <img src={logoLatitud} alt="" className="responsive-img padding-img modal-prelogin-img"/>
                        </div>
                        <div className="card-action center">
                           <a href="#">AUTOMOTOR</a>
                        </div>
                     </div>
                  </div>
               </div> */}
               <div className='controls'>
                  {/* <button className='close-btn'></button> */}
                  <button className='submit-btn' onClick={()=>setModalPreLogin("")}>Cerar</button>
               </div>
            </div>
         </div>
      </>
   )
}

export default ModalPreLoginTres